export var FinancialAnalysisGranularity;
(function (FinancialAnalysisGranularity) {
    FinancialAnalysisGranularity["WEEK"] = "WEEK";
    FinancialAnalysisGranularity["MONTH"] = "MONTH";
})(FinancialAnalysisGranularity || (FinancialAnalysisGranularity = {}));
//# sourceMappingURL=OrgMgmtFinancialAnalysis.js.map